declare var require: (moduleId: string) => any;

const d3Lazy: Function = require('bundle?lazy&name=d3!d3');
const nvd3Lazy: Function = require('bundle?lazy&name=d3!nvd3');
import * as moment from 'moment';
import * as _ from 'lodash';
import 'nvd3/build/nv.d3.css';

export default (ngModule) => {
  ngModule.directive('graficoHistoricoPreco', graficoHistoricoPreco);
};

function graficoHistoricoPreco() {
  return {
    restrict: 'E',
    template: `<div ng-show="vm.mostrar"><svg></svg></div>`,
    scope: {
      tipo: '@',
      dados: '=',
      mostrar: '='
    },
    controller: GraficoCtrl,
    controllerAs: 'vm',
    bindToController: true,
    link
  };
}

function link(scope, elem) {
  scope.vm = _.assign(scope.vm, {elem: elem.children()[0]});
}

GraficoCtrl.$inject = ['$timeout', '$filter', '$scope', '$window'];

function GraficoCtrl($timeout, $filter, $scope, $window) {
  const vm = this;
  let d3: any, nvd3: any, formatTime, parseDate;
  const formatValor = $filter('currency');

  d3Lazy(libD3 => {
    d3 = libD3;
    nvd3Lazy(libNvd3 => {
      nvd3 = libNvd3;
      $timeout(configurarGrafico);
    });
  });

  function configurarGrafico() {
    if (vm.tipo === 'diario') {
      parseDate = d3.time.format('%Y-%m-%d').parse;
      formatTime = d => moment(d).format('DD/MMM');
    } else if (vm.tipo === 'mensal') {
      parseDate = d3.time.format('%Y-%m').parse;
      formatTime = d => moment(d).format('MMM/YY');
    }

    if (vm.dados && parseDate) {
      vm.dados.forEach((d) => {
        d.data = parseDate(d.data);
        d.valor = parseFloat(d.valor);
      });

      criarGrafico();
    }
  }

  function criarGrafico() {
    nvd3.addGraph(() => {
      const chart = nvd3.models.lineChart()
        .x(d => d.data)
        .y(d => d.valor)
        .color(d3.scale.category10().range())
        .useInteractiveGuideline(true);

      const filter = (vm.dados.length > 9 ? (d, k) => k % 2 === 0 : () => true);

      chart.xAxis.tickValues(vm.dados.filter(filter).map(d => d.data)).tickFormat(formatTime);
      chart.yAxis.ticks(4).tickFormat((v) => formatValor(v, 'R$ ', 2));

      d3.select(vm.elem)
        .select('svg')
        .datum([{key: 'Preço', values: vm.dados}])
        .transition()
        .duration(500)
        .call(chart);

      const update = _.debounce(chart.update, 300);

      $scope.$watch(() => vm.mostrar, (mostrar) => {
        if (mostrar) {
          update();
        }
      });

      angular.element($window).bind('resize', update);
      $scope.$on('$destroy', () => angular.element($window).unbind('resize', update));

      return chart;
    });
  }
}



/** WEBPACK FOOTER **
 ** ../~/tslint-loader!./common/components/grafico/grafico-historico-preco.directive.ts
 **/